import { useIsDesktopDevice } from '../../tools/hooks/useIsDesktopDevice.ts';
import type UserMarketsDialogProperties from './UserMarketsDialog.properties.ts';
import UserMarketsDialogDesktopView from './desktop/UserMarketsDialog.desktop.view.tsx';

export default function UserMarketsDialogView(props: UserMarketsDialogProperties) {
  const isDesktop = useIsDesktopDevice();

  return <>{isDesktop && <UserMarketsDialogDesktopView {...props} />}</>;
}
